import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SetTourID, SetCityID, SetDeparture } from '../../actions/currentBooking';
import Spinner from '../shared/spinner';
import { FetchCapacity } from '../../actions/capacity';
import _pick from 'lodash/pick';
import _map from 'lodash/map';
import _orderBy from 'lodash/orderBy';
import _uniqBy from 'lodash/uniqBy';
import _filter from 'lodash/filter';



class BasketProductList extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      productDropdown:"0",
      hohoDropdown:"0",
      hohoCity:"0",
      products:[],
      cities:[],
      productIsOpen:false,
      hohoIsOpen:false, //OR FLEXI (BOG)
      cityIsOpen:false,
     }

     this.documentClickHandler = this.documentClickHandler.bind(this);
  }


  componentDidMount(){


    const { product, capacity, bookingGroup, SetTourID, SetCityID, SetDeparture } = this.props;


    //Rehydrate basket product list if data exist in state
    if(Object.keys(product.content).length !== 0 && capacity.data !== undefined){
      this.populateBasketProductList(null);
    }

    //If tour is booked and is hoho - clear selected date and initialise (The user press the back button after booking hoho tour)
    if(Object.keys(bookingGroup).length !== 0 && product.header.type === "hoho"){
      SetTourID("");
      SetCityID("0")
      SetDeparture("");
    }

    document.body.addEventListener('click', this.documentClickHandler);

  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  documentClickHandler(e){
    try{
      if(e.target.offsetParent.className !== "filterDropdown basket"){
        this.setState({
          productIsOpen:false,
          hohoIsOpen:false,
          cityIsOpen:false
        });
      }
    }catch(e){}

  }

  componentDidUpdate(prevProps, prevState) {

    const {
      product,
      departureDate,
      capacity,
      SetTourID
    } = this.props;

    if(product !== prevProps.product){
      this.populateBasketProductList(product);
    }

    if(departureDate !== prevProps.departureDate){
      //Set tourID from capacity response on date change
      if(departureDate !== "" && capacity.header.type === "fixed") {
        
        try{
          const tms_tour_id = (Object.keys(capacity).length > 0 && capacity.data.length > 0) ? _filter(capacity.data, ['departure_date', departureDate])[0].tms_tour_id : "";
          if(tms_tour_id !== undefined || tms_tour_id !== "") SetTourID(tms_tour_id);
        }catch(error){}

      }
    }
  }


  populateBasketProductList(_props){

    // 1. Populate products list
    // 2. Check if product product type is fixed and populate first value
    const productHeader = (_props === null) ? this.props.product.header : _props.header;
    const productMap = (_props === null) ? this.props.product.map : _props.map;

    //Check if tour has product options
    //Check if tour has map options - extract only the name and city id and re-order alphabetically
    const productOptions = productHeader.product_options.filter(item => item !== null) || [];
    const populateList = (productOptions.length === 0) ? [{"name":productHeader.name, "duration":productHeader.duration, "tour_id":productHeader.tour_id}] : productOptions;
    const productMapList = (productMap.length === 0) ? [] : _orderBy(_map(productMap, (item) => { return _pick(item, ['name', 'start_city_id'])}), ['name', 'asc']);


    this.setState({products: populateList}, () => {

        //Check if fixed tours has product options
        //- Load product with options or load single products
        //- Product with options - pre-select if tour_id matches product options header tour_id otherwise load default (first item)
        const preSelectTour = {
          name: (productHeader.product_options.length !== 0 && _filter(this.state.products, ['tour_id', productHeader.tour_id]).length > 0) ? _filter(this.state.products, ['tour_id', productHeader.tour_id])[0].name : this.state.products[0].name,
          tourID: (productHeader.product_options.length !== 0 && _filter(this.state.products, ['tour_id', productHeader.tour_id]).length > 0) ? _filter(this.state.products, ['tour_id', productHeader.tour_id])[0].tour_id : this.state.products[0].tour_id
        }

        if(productHeader.type === "fixed"){
          const hasProductOptions = (productHeader.product_options.length === 0) ? productHeader.tour_id : preSelectTour.tourID;
          const hasProductName = (productHeader.product_options.length === 0) ? productHeader.name : preSelectTour.name;

          this.onProductChange(null, hasProductOptions, hasProductName);
        }

      if(productHeader.type === "hoho"){

        //Preload hoho option if non - group_id is in the route
        const preSelectHoho = {
          name: (productHeader.product_options.length !== 0 && productHeader.group_id === productHeader.tour_id) ? "Select your pass" : preSelectTour.name,
          tourID: (productHeader.product_options.length !== 0 && productHeader.group_id === productHeader.tour_id) ? "" : preSelectTour.tourID,
        }

        this.onHohoChange(null, preSelectHoho.tourID, preSelectHoho.name);

        //load cities
        this.setState({
          cities:productMapList,
          hohoCity:"Select start city"
        })
      }


      if(productHeader.type === "flexi"){

        this.onHohoChange(null, "", "Select Flexi options (any)");

        //load cities
        this.setState({
          cities:_uniqBy(productMapList, 'name'),
          hohoCity:"Select start city"
        })
      }


    });



  }

  onProductChange(e, value, productName){

    const { FetchCapacity, currency:{iso_currency_code}, SetTourID} = this.props;

    // 1. set active product
    // 2. fetch capacity for current selected tour
    // 3. reset departure date
    this.setState({productDropdown:productName, productIsOpen:false});

    FetchCapacity(value, iso_currency_code, "")

    SetTourID(value);

    this.onCalendarRemove();

  }

  onHohoChange(e, value, productName){

    const { FetchCapacity, SetTourID, currency:{iso_currency_code}, cityID  } = this.props;

    // 1. set active hoho product
    // 2. fetch capacity for current hoho tour
    this.setState({hohoDropdown:productName, hohoIsOpen:false });

    SetTourID(value);

    if(value !== "" && cityID !== "0"){
      FetchCapacity(value, iso_currency_code, cityID);
      this.onCalendarRemove();
    }

  }

  onCityChange(e,value, productName){

    const { FetchCapacity, currency:{iso_currency_code}, SetCityID, tourID  } = this.props;

    //set active start city
    this.setState({hohoCity:productName, cityIsOpen:false });

    SetCityID(value);

    if(tourID !== ""){
      FetchCapacity(tourID, iso_currency_code, value);
      this.onCalendarRemove();
    }

  }

  onCalendarRemove(){
    //Remove calender selection when dropdown is change
    const { SetDeparture, departureDate } = this.props;

    if(departureDate !== ""){

      try{
        document.querySelector('.DayPicker-Day--selected').classList.add('DayPicker-Day--available');
        document.querySelector('.DayPicker-Day--available').classList.remove('DayPicker-Day--selected');
        document.querySelector('.DayPicker-Day--available').setAttribute('aria-selected', 'false');
      }catch(e){}

      let durationClass = document.querySelectorAll('[data-duration]');
      for(let i = 0; i < durationClass.length; i++){
        durationClass[i].setAttribute('data-duration', '');
      }
      SetDeparture("");
    }
  }



  onProductClick(e){
    e.preventDefault();
    this.setState({ productIsOpen:!this.state.productIsOpen });
  }

  onHohoClick(e){
    e.preventDefault();
    this.setState({ hohoIsOpen:!this.state.hohoIsOpen });
  }

  onCityClick(e){
    e.preventDefault();
    this.setState({ cityIsOpen:!this.state.cityIsOpen });
  }

  characterLength(str){

    if(str.length > 20  && str.length < 36){
      return "small-text";
    }
    else if(str.length > 36){
      return "x-small-text";
    }else{
      return "";
    }

  }



  renderProducts(){

    const { productDropdown, productIsOpen, products } = this.state;

    return (
    <div className="filterDropdown basket basket-dropdown">
      <div className="row">
        <div className="columns small-12">
          <a onClick={ e => this.onProductClick(e) } className="filterDropdown-btn">
            <div className="row">
              <div className="columns small-10">
                <p className={`${this.characterLength(productDropdown)}`}>{productDropdown}</p>
              </div>
              <div className="columns small-2">
                <i className={`fa fa-chevron-down ${productIsOpen ? 'active' : ''}`}  aria-hidden="true"></i>
              </div>
            </div>
          </a>

        </div>
        <div className="columns small-12">
          <ul style={{display: productIsOpen ? 'block':'none' }}>
            {
              products.map(product => {
                return (
                  <li
                    value={product.tour_id}
                    onClick={e => this.onProductChange(e, product.tour_id, product.name)}
                    key={product.tour_id}>{product.name}
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    </div>
    );
  }

  renderHoho(){

    const { hohoDropdown, hohoIsOpen, products } = this.state;

    return (
      <div className="row">
        <div className="columns small-12 large-6 col-left-mod-large">
           { this.renderCities() }
        </div>
        <div className="columns small-12 large-6 col-right-mod-large">
          <div className="filterDropdown basket basket-dropdown">
            <div className="row">
              <div className="columns small-12">
                <a onClick={ e => this.onHohoClick(e) } className="filterDropdown-btn">
                  <div className="row">
                    <div className="columns small-10">
                      <p className={`${this.characterLength(hohoDropdown)}`}>{hohoDropdown}</p>
                    </div>

                    <div className="columns small-2">
                      <i className={`fa fa-chevron-down ${hohoIsOpen ? 'active' : ''}`} aria-hidden="true"></i>
                    </div>
                  </div>
                </a>
              </div>
              <div className="columns small-12">
                <ul style={{display: hohoIsOpen ? 'block':'none' }}>
                  {
                    products.map((product, index) => {
                      return (
                        <li
                          value={product.tour_id}
                          onClick={e => this.onHohoChange(e, product.tour_id, product.name)}
                          key={product.tour_id}>{product.name}
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
     </div>
    )
  }

  renderCities(){

    const { hohoDropdown, hohoCity, cityIsOpen, cities } = this.state;
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

    return (
      <div className="filterDropdown basket basket-dropdown">
        <div className="row">
          <div className="columns small-12 overflow-hidden">
            <a onClick={ e => this.onCityClick(e) } className="filterDropdown-btn">
              <div className="row">
                <div className={`columns small-10 ${this.characterLength(hohoDropdown)}`}>
                  {hohoCity}
                </div>
                <div className="columns small-2">
                  <i className="fa fa-chevron-down" aria-hidden="true"></i>
                </div>
              </div>
            </a>
          </div>
          <div className="columns small-12">
            <ul className="cities" style={{display: cityIsOpen ? 'block':'none' }}>
              {
                cities.map(city => {
                  return (
                    <li
                      value={city.start_city_id}
                      onClick={e => this.onCityChange(e, city.start_city_id, renderHTML(city.name))}
                      key={city.start_city_id}>{renderHTML(city.name)}
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
      </div>
    )
  }


  render(){

    const { product:{header:{type}} } = this.props;

    if(type === undefined){
      return <Spinner text="Loading products..." loadClass="loading-spinner" />
    }else{
      return (type === "fixed") ? this.renderProducts() : this.renderHoho();
    }
  }

}

function mapStateToProps(state){
  return {
    product:state.product,
    currency:state.currency,
    capacity:state.capacity.data,
    tourID:state.currentBooking.trips[0].tour_id,
    cityID:state.currentBooking.trips[0].city_id,
    departureDate:state.currentBooking.trips[0].departure_date,
    bookingGroup:state.bookingGroup.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
   SetTourID,
   SetCityID,
   SetDeparture,
   FetchCapacity
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BasketProductList);



// WEBPACK FOOTER //
// ./src/components/basket/basketproductlist.js